import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import PostHooks from "../../../../Api/PostHooks";
import { LoadingButton } from "@mui/lab";
import { useEffect } from "react";
import AlertComponent from "../../../../Components/AlertComponent";

const GuarantorApprovalForm = ({ data, onClose, onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, responseData, request] = PostHooks();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [status, setStatus] = useState();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const onSubmit = async (e) => {
    let formData = {
      id: data.id,
      amount: e.amount,
      description: status,
      status: status,
    };

    try {
      await request({
        url: "/approve_gurantorship_req",
        body: formData,
      });
    } catch (error) {
      console.log("guarantor approval err", error);

      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  useEffect(() => {
    if (!responseData) {
      return;
    }

    if (responseData.status) {
      if (responseData.status === 200 && responseData.data.StatusCode === 0) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Gurantor Request Approved Successfully!",
        });

        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          responseData?.data?.StatusMessage ??
          responseData?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    }
  }, [responseData, onClose, onSuccess]);

  return (
    <div>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl
          fullWidth
          sx={{
            my: "20px",
          }}
        >
          <InputLabel id="status">Status</InputLabel>
          <Select
            labelId="status"
            id="status"
            defaultValue=""
            value={status}
            label="Status"
            onChange={(e) => setStatus(e.target.value)}
            required
          >
            <MenuItem value="accept">Accept </MenuItem>
            <MenuItem value="decline">Decline </MenuItem>
          </Select>
        </FormControl>

        {status === "accept" && (
          <FormControl
            fullWidth
            sx={{
              my: "30px",
            }}
            error={!!errors.maximum_guarantor_percentage}
          >
            <InputLabel htmlFor="amount">Amount</InputLabel>
            <OutlinedInput
              id="amount"
              type="number"
              label="Amount"
              {...register("amount")}
              defaultValue="0"
              onWheel={(event) => {
                event.target.blur();
              }}
              inputProps={{ step: "any", min: 0 }}
            />
            {errors.amount && <FormHelperText>Enter an amount!</FormHelperText>}
          </FormControl>
        )}

        <Box
          sx={{
            pt: "20px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            size="large"
            type="reset"
            variant="outlined"
            onClick={() => onClose()}
          >
            cancel
          </Button>
          <LoadingButton
            variant="contained"
            sx={{ ml: "10px" }}
            size="large"
            type="submit"
            loading={loading}
          >
            Update
          </LoadingButton>
        </Box>
      </form>
    </div>
  );
};

export default GuarantorApprovalForm;
